import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { RibbonModule, TabModule, TabService } from '@hdms/shared/ui-core';

import { ContactHeaderComponent } from './contact-header.component';

@NgModule({
  declarations: [ContactHeaderComponent],
  imports: [CommonModule, TranslationModule, TabModule, RibbonModule],
  providers: [TabService],
  exports: [ContactHeaderComponent]
})
export class ContactHeaderModule {}
